import { jsx } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/shared/components/sliders/slider.tsx
function SliderTrack({ className, ...props }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("media-slider-track", className),
		...props
	});
}
function SliderFill({ className, ...props }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("media-slider-fill", className),
		...props
	});
}
function SliderBuffer({ className, ...props }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("media-slider-buffer", className),
		...props
	});
}
function SliderThumb({ className, ...props }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("media-slider-thumb", className),
		...props
	});
}
//#endregion
export { SliderBuffer, SliderFill, SliderThumb, SliderTrack };

//# sourceMappingURL=slider.js.map